module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("MARY JO BANG")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#sec2"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("The Eye Like A Strange Balloon")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#sec3"
    }
  }, [_vm._v("High Art")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_a#sec4"
    }
  }, [_vm._v("Mrs. Autumn and Her Two Daughters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_b#sec5"
    }
  }, [_vm._v("Untitled # 70 (Or, The Question of Remains)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_c#sec6"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Elegy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_c#sec7"
    }
  }, [_vm._v("Landscape with the Fall of Icarus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_d#sec8"
    }
  }, [_vm._v("Words")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_e#sec9"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("The Bride of E")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_e#sec10"
    }
  }, [_vm._v("And as in Alice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_f#sec11"
    }
  }, [_vm._v("B Is for Beckett")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_g#sec12"
    }
  }, [_vm._v("C Is for Cher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_h#sec13"
    }
  }, [_vm._v("In the Present and Probable Future")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_i#sec14"
    }
  }, [_vm._v("From the "), _c('em', [_vm._v("Mrs. Dalloway")]), _vm._v(" series")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_i#sec15"
    }
  }, [_vm._v("Opened and Shut")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_j#sec16"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETICS STATEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1_k#sec17"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ARTICULATIONS OF ARTIFICE IN THE WORK OF MARY JO BANG")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_vm._v("by Karla Kelsey")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LUCILLE CLIFTON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Good Woman: Poems and a Memoir 1969–1980")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#sec21a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[the light that came to Lucille Clifton]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_a#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Quilting")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_a#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("eve’s version")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_b#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("lucifer speaks in his own voice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_c#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("The Book of Light")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_c#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("daughters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_c#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[won’t you celebrate with me]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_d#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("leda 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_e#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("leda 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_f#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("The Terrible Stories")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_f#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("telling our stories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_g#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Mercy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_g#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("the river between us")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_h#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Voices")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_h#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sorrows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_i#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETICS STATEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_i#sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpts from an Interview with Charles Rowell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2_j#sec38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LUCILLE CLIFTON")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S COMMUNAL")]), _vm._v(" “i”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_vm._v("by Adrienne McCormick")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KIMIKO HAHN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Mosquito and Ant")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#sec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orchid Root")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3_a#sec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garnet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3_b#sec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("The Narrow Road to the Interior")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3_b#sec46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Utica Station Dep.10:07 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")]), _vm._v(" to N.Y. Penn Station")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3_c#sec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("The Artist’s Daughter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3_c#sec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Childhood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3_d#sec49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Like Lavrinia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3_e#sec50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETICS STATEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3_e#sec51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Still "), _c('em', [_vm._v("Writing the Body")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3_f#sec52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“"), _c('span', {
    staticClass: "small"
  }, [_vm._v("I WANT TO GO WHERE THE HYSTERIC RESIDES")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3_f#sec53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kimiko Hahn’s Re-Articulation of the Feminine in Poetry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_vm._v("by Zhou Xiaojing")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CARLA HARRYMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Baby")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#sec58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[Now. Word. Technology.]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4_a#sec59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[Dark. Swat. Land.]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4_b#sec60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[The. Open. Box.]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4_c#sec61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[Baby. N. Baseball. Song.]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4_c#sec62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[Wartime Surroundings.]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4_d#sec63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Adorno’s Noise")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4_d#sec64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("["), _c('em', [_vm._v("consents to a few statements one knows ultimately to implicate murder")]), _vm._v("]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4_e#sec65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("["), _c('em', [_vm._v("it is difficult to write satire")]), _vm._v("]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4_f#sec66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("["), _c('em', [_vm._v("the opposite of slackness")]), _vm._v("]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4_g#sec67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETICS STATEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4_g#sec68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Siren")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4_h#sec69",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LISTENING IN ON CARLA HARRYMAN")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" "), _c('em', [_c('span', {
    staticClass: "small"
  }, [_vm._v("BABY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_vm._v("by Christine Hume")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ERÍN MOURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("O Cidadán")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#sec74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("document32 (inviolable)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5_a#sec75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("document33 (arena)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5_b#sec76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleventh "), _c('em', [_vm._v("Impermeable")]), _vm._v(" of the Carthage of Harms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5_c#sec77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Little Theatres")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5_c#sec78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theatre of the Confluence (A Carixa)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5_d#sec79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theatre of the Stones that Ran (Fontao, 1943)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5_e#sec80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Theatre of the Millo Seco (Botos)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5_f#sec81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("O Cadoiro")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5_f#sec82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[[T]he best woman i ever saw.]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5_g#sec83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[This night of liquid storms, high noon s dwelling]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5_h#sec84",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETICS STATEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5_h#sec85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Practice of Possibility, a Life in Languages")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5_i#sec86",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MOURE")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S ABRASIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_vm._v("by Aaron Kunin")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LAURA MULLEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#sec90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("The Surface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6_b#sec91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("The Tales of Horror")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6_b#sec92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(A Pretty Girl is Like a Melody)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6_c#sec93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("After I Was Dead")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6_c#sec94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6_d#sec95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35 ½")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6_e#sec96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Murmur")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6_f#sec97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Subject")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6_f#sec98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Circles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6_g#sec99",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETICS STATEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6_h#sec100",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LAURA MULLEN: THREATENED AS THREAT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6_h#sec101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rethinking Gender and Genre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_vm._v("by Kass Fleisher")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EILEEN MYLES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#sec105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transitions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7_a#sec106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snowflake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7_b#sec107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To My Class")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7_c#sec108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7_d#sec109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7_e#sec110",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETICS STATEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7_f#sec111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WHEN WE")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RE ALONE IN PUBLIC")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7_f#sec112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Poetry of Eileen Myles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_vm._v("by Maggie Nelson")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M. NOURBESE PHILIP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3v"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#sec116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("She Tries Her Tongue; Her Silence Softly Breaks")]), _c('br'), _vm._v("Discourse on the Logic of Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8_e#sec117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Universal Grammar")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8_k#sec118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Zong!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8_k#sec119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Os, Zong! #2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8_l#sec120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zong! #4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8_m#sec121",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ferrum")]), _vm._v(" (excerpt)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8_r#sec122",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETICS STATEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8_r#sec123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ignoring Poetry (a work in progress)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8_s#sec124",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE LANGUAGE OF TRAUMA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8_s#sec125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith and Atheism in M. NourbeSe Philip’s Poetry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_vm._v("by Dawn Lundy Martin")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOAN RETALLACK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#sec129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Errata 5uite")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9_b#sec130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("How to Do Things with Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9_b#sec131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Woman in the Chinese Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9_c#sec132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("MONGRELISME")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9_f#sec133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("MEMNOIR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9_f#sec134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curiosity and the Claim to Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9_g#sec135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lost Brief Case Conjecture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9_h#sec136",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETICS STATEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9_h#sec137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Procedural Elegies: N Plus Zero")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9_i#sec138",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE METHOD")]), _vm._v(" “"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN "), _c('em', [_vm._v("MEDIAS")]), _vm._v(" MESS")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_vm._v("by Jena Osman")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LISA ROBERTSON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#sec142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("The Weather")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#sec143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Residence at C___")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10_a#sec144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuesday")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10_b#sec145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Residence at C___")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10_c#sec146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10_d#sec147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Utopia (R’s Boat)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10_d#sec148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[In the spring of 1979]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10_e#sec149",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETICS STATEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10_e#sec150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soft Architecture: A Manifesto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10_f#sec151",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ABOUT SURFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10_f#sec152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lisa Robertson’s Poetics of Elegance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_vm._v("by Sina Queyras")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. D. WRIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#sec156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Steal Away")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#sec157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Floating Trees")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_a#sec158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Privacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_b#sec159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Cooling Time")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_b#sec160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[only the crossing counts.]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_b#sec161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[elation washed over our absence toward everything in the increasing darkness]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_c#sec162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("One Big Self: An Investigation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_c#sec163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dear Prisoner,")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_d#sec164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Dear Conflicted Reader,")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_e#sec165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dear Child of God,")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_e#sec166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[Mack trapped a spider]")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_f#sec167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From "), _c('em', [_vm._v("Rising, Falling, Hovering")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_f#sec168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Re: Happiness, in pursuit thereof")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_g#sec169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Like Having a Light at Your Back You Can’t See but You Can Still Feel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_h#sec170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Like a Prisoner of Soft Words")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_i#sec171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Like Something in His Handwriting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_j#sec172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Like Something Flying Backwards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_k#sec173",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("POETICS STATEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_k#sec174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My American Scrawl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11_l#sec175",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE BORDER-CROSSING RELATIONAL POETRY OF C. D. WRIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_vm._v("by Suzanne Wise")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/contributors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Audio clips of many of the poems in this book"), _c('br'), _vm._v("are available at the book’s companion website:")]), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.wesleyan.edu/wespress.aptc3",
      "target": "_blank"
    }
  }, [_vm._v("www.wesleyan.edu/wespress.aptc3")])]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0